// extracted by mini-css-extract-plugin
module.exports = {"container":"Terms_container__mtrEi","subtitle":"Terms_subtitle__O19Lj","adjust_terms":"Terms_adjust_terms__eT20s","textoCp":"Terms_textoCp__3GbPn"};